(() => {
  const header = document.querySelector('[data-header]');
  const syncHeader = () => {
    if (!header) return;
    const point = window.scrollY + window.innerHeight * .2;
    const light = document.querySelector('.collection-section, .page-content');
    const dark = document.querySelector('.site-footer');
    const inBox = (node) => node && point >= node.offsetTop && point < node.offsetTop + node.offsetHeight;
    header.classList.toggle('on-light', inBox(light));
    header.classList.toggle('on-dark', !inBox(light) || inBox(dark));
  };
  window.addEventListener('scroll', syncHeader, { passive: true });
  syncHeader();
  const productObserver = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting && entry.target.classList.add('is-visible')), { threshold: .12 });
  document.querySelectorAll('.product-card').forEach((card) => productObserver.observe(card));
})();
